import {createReducer} from '@reduxjs/toolkit';
import {setPreference} from '@src/actions/settings.js';
import {
  SETTINGS_KEY,
  coordinateSystems as coordinates,
  preferenceGroups,
} from '@src/constants';
import {
  AREA_UNITS,
  DISTANCE_UNITS,
  MEASUREMENT_SYSTEMS,
} from '@src/constants/measureUnits.js';
import {get as getStored} from '@src/utils/store.js';

const initialState = {
  [preferenceGroups.measurementSystem]: MEASUREMENT_SYSTEMS.metric,
  [preferenceGroups.coordinateSystem]: coordinates.dd,
  [preferenceGroups.distanceUnitsMetric]: DISTANCE_UNITS.metric.km,
  [preferenceGroups.areaUnitsMetric]: AREA_UNITS.metric.km2,
  [preferenceGroups.distanceUnitsUSC]: DISTANCE_UNITS.usc.mi,
  [preferenceGroups.areaUnitsUSC]: AREA_UNITS.usc.mi2,
};

const storedState = getStored(SETTINGS_KEY);

const settings = createReducer({...initialState, ...storedState}, builder => {
  builder.addCase(setPreference, (state, {payload}) => {
    if (!payload) {
      return state;
    }

    // Check if its a valid key
    const isKey = preferenceGroups[payload.key];

    // Check for valid coordinate system value
    const isCoord = Object.keys(coordinates).filter(
      value => coordinates[value] === payload.value,
    ).length;

    // Check for valid measurement system value
    const isMeasurementSystem = Object.keys(MEASUREMENT_SYSTEMS).filter(
      value => MEASUREMENT_SYSTEMS[value] === payload.value,
    ).length;

    // Check for valid distance units
    const systemDISTANCE_UNITS =
      state.measurementSystem === MEASUREMENT_SYSTEMS.metric
        ? DISTANCE_UNITS.metric
        : DISTANCE_UNITS.usc;

    const isValidDistanceUnit = Object.keys(systemDISTANCE_UNITS).filter(
      value => systemDISTANCE_UNITS[value] === payload.value,
    ).length;

    // Check for valid area units
    const systemAreaUnits =
      state.measurementSystem === MEASUREMENT_SYSTEMS.metric
        ? AREA_UNITS.metric
        : AREA_UNITS.usc;

    const isValidAreaUnit = Object.keys(systemAreaUnits).filter(
      value => systemAreaUnits[value] === payload.value,
    ).length;

    // Final check for valid values
    const isValue =
      isCoord || isMeasurementSystem || isValidDistanceUnit || isValidAreaUnit;

    // Set the state if the key value pair is valid
    if (isKey && isValue) {
      state[payload.key] = payload.value;
    }

    return state;
  });
});

export default settings;
